import { render, staticRenderFns } from "./GeneralAdvanced.vue?vue&type=template&id=523c886d&"
import script from "./GeneralAdvanced.vue?vue&type=script&lang=js&"
export * from "./GeneralAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports